import React, { useState } from 'react'
import AdminPage from '../../../../components/page/AdminPage'
import { Divider, Tab, Tabs } from '@mui/material'
import Studios from './Studios'
import Memberships from './Memberships'
import TabPanel from '../../../../components/TabPanel'

const Settings = () => {
  const [tabs, setTabs] = useState(0)

  const handleTabChange = (event, newValue) => {
    setTabs(newValue)
  }

  return (
    <AdminPage>
      <Tabs value={tabs} onChange={handleTabChange}>
        <Tab label='Memberships' />
        <Tab label='Studios' />
        <Tab label='Audit Log' />
      </Tabs>
      <Divider />
      <TabPanel value={tabs} index={0}>
        <Memberships />
      </TabPanel>
      <TabPanel value={tabs} index={1}>
        <Studios />
      </TabPanel>
    </AdminPage>
  )
}

export default Settings
